export interface ILabelActions {
	get: (
		labelName: string,
		placeholder?: string,
		additionalPlaceholder?: string,
	) => string;
}

class LabelService implements ILabelActions {
	static labelPrefix = 'RESPONSIVE_';
	private storeLabels: any;
	private DEV_ENV: boolean;
	constructor(DEV_ENV: boolean = false, labels: any) {
		this.DEV_ENV = DEV_ENV;
		this.storeLabels = labels;
	}

	private replacePlaceholder(
		label: string,
		placeholderText: string,
		additionalPlaceholderText: string,
	) {
		if (!label) return;

		return label
			.replace('%2', additionalPlaceholderText)
			.replace('%1', placeholderText);
	}

	public get(
		labelName: string,
		placeholder?: string,
		additionalPlaceholder: string = '',
	): string {
		let label: string | null = null;

		if (labelName !== undefined) {
			// Add the prefix if it isnt there.
			if (labelName.indexOf('RESPONSIVE_') === -1) {
				labelName = LabelService.labelPrefix + labelName.toLocaleUpperCase();
			}

			try {
				label = placeholder
					? this.replacePlaceholder(
							this.storeLabels[labelName],
							placeholder,
							additionalPlaceholder,
						)
					: this.storeLabels[labelName];
			} catch (e) {
				console.log(`Label Error ${labelName}`);
			}
		}

		if (typeof label === 'string') {
			return label;
		}

		// Dev logging
		if (this.DEV_ENV) {
			console.log(`Label missing: ${labelName}.`);
		}

		return String();
	}
}

export default LabelService;
